module.exports = __webpack_public_path__ + "static/about-us-bg-a2e759afec3433f885056373e4c676ef.jpg";